import { Button } from "antd";
import classNames from "classnames";
import BaseModal, { BaseModalProps, Variant } from "../BaseModal/index";
import styles from "./style.module.scss";

export interface VLActionModalProps extends BaseModalProps {
  onClick: () => void;
  actionLabel?: string;
  loading?: boolean;
  direction?: "column" | "row";
}

const defaultActionLabels: Record<Variant, string> = {
  error: "Try Again",
  success: "Continue",
  info: "OK",
  general: "OK",
};

const VLActionModal = ({
  isOpen,
  onClose,
  onClick,
  variant,
  children,
  className,
  actionLabel,
  loading = false,
  direction = "column",
  headers,
}: VLActionModalProps) => {
  const footerClassNames = classNames(styles.footer, {
    [styles.info]: variant === "info",
    [styles.error]: variant === "error",
    [styles.success]: variant === "success",
  });

  const footer = (
    <div className={footerClassNames}>
      <Button
        type="primary"
        data-testid="action-button"
        loading={loading}
        onClick={() => {
          onClick();
        }}
      >
        {actionLabel || (variant && defaultActionLabels[variant])}
      </Button>
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      variant={variant}
      headers={headers}
      footer={direction === "row" ? undefined : footer}
      className={className}
    >
      <div className={styles[direction]}>
        {children}
        {direction === "row" && footer}
      </div>
    </BaseModal>
  );
};

export default VLActionModal;
